import React from "react";
import "./banner.scss";

const Banner = ({
  color = "white",
  opacity = 1,
  children,
  className = "",
}: {
  color?: string;
  opacity?: number;
  children: React.ReactNode;
  className?: string;
}) => {
  const styles = { background: color, opacity: opacity };
  return (
    <div className={`banner ${className}`}>
      <div className="banner__overlay" style={styles}></div>
      {children}
    </div>
  );
};

const Image = ({ children }: { children: React.ReactNode }) => {
  return <div className="banner__image">{children}</div>;
};
Banner.Image = Image;

const Content = ({ children }: { children: React.ReactNode }) => {
  return <div className="banner__content">{children}</div>;
};
Banner.Content = Content;

export default Banner;
